import { render, staticRenderFns } from "./user_block.vue?vue&type=template&id=0a257444&scoped=true&"
import script from "./user_block.vue?vue&type=script&lang=js&"
export * from "./user_block.vue?vue&type=script&lang=js&"
import style0 from "./user_block.vue?vue&type=style&index=0&id=0a257444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a257444",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a257444')) {
      api.createRecord('0a257444', component.options)
    } else {
      api.reload('0a257444', component.options)
    }
    module.hot.accept("./user_block.vue?vue&type=template&id=0a257444&scoped=true&", function () {
      api.rerender('0a257444', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/shared/user/user_block/user_block.vue"
export default component.exports